<span [ngClass]="{disabled: !selectedRows || selectedRows.length === 0}" class="button"
	(click)="cloneClicked(selectedRows)">
	<i class="fa fa-copy"></i>{{ 'CLONE_TO_PUBLICATION' | translate }}
</span>

<ng-template #cloningInfoTemplate>
	<div class="clone-panel">
		<div class="new-clone" *ngIf="entitiesToClone?.length">
			<h3>Clone: </h3>
			<ul class="entities">
				<li class="entity-to-clone" *ngFor="let entityToClone of entitiesToClone">
					<a [href]="getEntityLink({entityId: entityToClone.id, entityType: entityToClone.type | lowercase})"
						target="_blank">{{ entityToClone.name || entityToClone.title || entityToClone.label }} ({{
						entityToClone.type }} {{ entityToClone.id }})</a>
				</li>
			</ul>
			<bb-form-element [label]="'TARGET_PUBLICATION' | translate">
				<input [(ngModel)]="destinationUrl" type="text" name="destinationUrl" [placeholder]="placeholder"
					placeholder="PUBLICATION.bbvms.com" />
			</bb-form-element>
			<button (click)="cloneEntities(entitiesToClone, destinationUrl)" class="start button"
				[class.disabled]="!destinationUrl || destinationUrl === 'PUBLICATION.bbvms.com'"
				[disabled]="!destinationUrl || destinationUrl === 'PUBLICATION.bbvms.com'">Start cloning</button>
		</div>
		<h3>Migration jobs</h3>
		<div *ngIf="!migrationJobs?.length">
			No migration jobs yet.
		</div>
		<div class="migration-job" *ngFor="let migrationJob of migrationJobs">
			<div class="job-info" [class.open]="migrationJob.opened"
				(click)="migrationJob.opened = !migrationJob.opened" [title]="'Journal: ' + migrationJob.journal">
				<div class="id">
					ID: {{ migrationJob.id }}
				</div>
				<div class="link-from">
					<a [href]="getEntityLink({entityId: migrationJob.oid, entityType: migrationJob.otype})"
						target="_blank">{{ migrationJob.otype + ' ' + migrationJob.oid }}</a>
				</div>
				<div class="destination">
					<a [href]="'https://' + migrationJob.destinationUrl" target="_blank">
						{{migrationJob.destinationUrl}}
					</a>
				</div>
				<div class="status">{{migrationJob.state}}</div>
			</div>


			<bb-table-container *ngIf="migrationJob.messages?.length" [hidden]="!migrationJob?.opened">

				<bb-table-header>
					<bb-table-header-cell class="icon"></bb-table-header-cell>
					<bb-table-header-cell property="event">{{ 'EVENT' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="message">{{ 'MESSAGE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="from-entity">{{ 'ENTITY' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="cloned-entity">{{ 'CLONE_AND_PARENT' | translate }}
					</bb-table-header-cell>
				</bb-table-header>

				<bb-table-row *ngFor="let ev of migrationJob.messages" [row]="ev" (click)="log(ev)">
					<bb-table-cell><span *ngIf="ev.payload?.entity" [innerHTML]="ev.payload?.entity | clipIcon"></span>
					</bb-table-cell>
					<bb-table-cell property="event">{{ ev.ev }}</bb-table-cell>
					<bb-table-cell property="message" class="overflow" [title]="ev.payload?.msg">
						{{ ev.payload?.msg }}
					</bb-table-cell>
					<bb-table-cell property="from-entity"><a [href]="getEntityLink(ev.payload?.entity)" target="_blank"
							[hidden]="!ev.payload?.entity?.entityId">{{ ev.payload?.entity?.entityType + ' ' +
							ev.payload?.entity?.entityId }}</a></bb-table-cell>
					<bb-table-cell property="cloned-entity">
						<a [href]="getEntityLink(ev.payload?.entity, migrationJob.destinationUrl)" target="_blank"
							[hidden]="!ev.payload?.entity?.newEntityId">
							{{ ev.payload?.entity?.entityType + ' ' + ev.payload?.entity?.newEntityId}}
							<span [hidden]="!ev.payload?.entity?.newParentId">
								({{ (ev.payload?.entity?.parentType ? (ev.payload?.entity?.parentType + ' ') : '') +
								ev.payload?.entity?.newParentId }})
							</span>
						</a>
					</bb-table-cell>
				</bb-table-row>

			</bb-table-container>
		</div>
	</div>
</ng-template>
